import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractEntityGridColumnComponent } from '@entity-framework/entity-grid/state/abstract-entity-grid-column.component';
import { BureauPaymentListItem } from '@app/bureau/payments/payment-status/models/bureau-payment-list-item';
import { Router } from '@angular/router';
import { BureauPaymentStatusChangeService } from '../services/bureau-payment-status.service';
import { BureauPermissionsService } from '@app/bureau/shared/bureau-permissions.service';

@Component({
  selector: 'app-bureau-payments-status-column',
  template: `
    <div class="row" tid="payments-status-column">
      <div class="col">
        @if (
          listItem.status === 'NotAuthorised' ||
          listItem.status === 'New' ||
          ((listItem.status === 'PaidByEmployer' || listItem.status === 'Submitted') && bureauPermissions.hasBureauManagerPermissions())
        ) {
          <mat-select
            [value]="selectedStatus(listItem.status)"
            tid="payment-status"
            [class]="'status-item status-' + listItem.status?.toLowerCase()"
            (selectionChange)="confirmStatusChange($event, listItem)"
            [disabled]="bureauPaymentService.inFlight$ | async"
          >
            @for (status of this.statusToDropdownOptions(listItem.status); track status) {
              <mat-option [hidden]="status === selectedStatus(listItem.status)" [value]="status">
                {{ status }}
              </mat-option>
            }
          </mat-select>
        } @else {
          <label [class]="'status-item status-' + this.listItem.status?.toLowerCase()">{{
            listItem.status === 'PaidByEmployer' ? 'Paid by employer' : listItem.status
          }}</label>
        }
      </div>
    </div>
  `,
  styleUrl: '../../../../bank-files/entity-grid/bureau-bank-file-status/bureau-bank-file-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class BureauPaymentsStatusColumnComponent extends AbstractEntityGridColumnComponent<BureauPaymentListItem> {
  constructor(
    private router: Router,
    public bureauPermissions: BureauPermissionsService,
    public bureauPaymentService: BureauPaymentStatusChangeService
  ) {
    super();
  }

  confirmStatusChange(event, listItem: BureauPaymentListItem) {
    const selectedValue = event.value;
    event.source.value = this.selectedStatus(listItem.status);

    if (selectedValue === 'Paid by bureau') {
      this.bureauPaymentService.reversePaidByEmployerBankFileWithDateCheck(listItem);
    } else if (selectedValue === 'Paid by employer') {
      this.router.navigate(
        [
          '',
          {
            outlets: {
              modal: ['bureau', 'payments', 'payment-status', 'paid-by-employer', listItem.id, { paymentStatus: listItem.status }]
            }
          }
        ],
        {
          queryParamsHandling: 'preserve'
        }
      );
    }
  }

  selectedStatus(option: string): string {
    const map: Record<string, string> = {
      New: 'New',
      PaidByEmployer: 'Paid by employer',
      Submitted: 'Submitted',
      NotAuthorised: 'Not authorised'
    };

    return map[option] ?? 'Not authorised';
  }

  statusToDropdownOptions(option: string): string[] {
    const options: string[] = [];

    const addPaidByEmployer = () => options.push('Paid by employer');

    switch (option) {
      case 'NotAuthorised':
      case 'New':
        addPaidByEmployer();
        options.push(this.selectedStatus(option));
        break;

      case 'PaidByEmployer':
        addPaidByEmployer();
        if (this.bureauPermissions.hasBureauManagerPermissions()) {
          options.push('Paid by bureau');
        }
        break;

      case 'Submitted':
        if (this.bureauPermissions.hasBureauManagerPermissions()) {
          addPaidByEmployer();
          options.push(this.selectedStatus(option));
        }
        break;
    }

    return options;
  }
}
